import { createApp } from 'vue';
import App from './App.vue';
import { createMetaManager } from 'vue-meta';  // Используем createMetaManager для Vue 3
import 'overlayscrollbars/styles/overlayscrollbars.css';
import mask from './directives/mask';
import popupTall from './directives/popupTall';
import iosScrollbar from './directives/iosScrollbar';
import osScrollbar from './directives/osScrollbar';
import autogrowTextarea from './directives/autogrowTextarea';
import router from './router/index';

const app = createApp(App);

app.use(router);
app.use(createMetaManager());  // Используем createMetaManager вместо app.use(VueMeta)

app.directive('mask', mask);
app.directive('popup-tall', popupTall);
app.directive('ios-scrollbar', iosScrollbar);
app.directive('os-scrollbar', osScrollbar);
app.directive('autogrow-textarea', autogrowTextarea);
app.mount('#app');
